import { createSelector } from 'reselect';

import {
  FETCH_PROJECTS_INFO_SUCCESS,
} from '../../actions/projectsInfo';

const initialState = {
info: {
  projects: [],
  resource_properties: {},
}
};

export default function projectsInfoReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PROJECTS_INFO_SUCCESS:
      return {
        ...state,
        info: action.payload.data,
      };
    default:
      return state;
  }
}

function getProjectInfo(state) {
  return state.projectsInfo.info;
}

export const projectsInfoSelector = createSelector(
  [getProjectInfo],
  info => info
);
